// The DEV environment (nirlat.*.dev.shtibel.com) — built with `npm run build:devenv`, see docs/dev-environment-setup.md

export const environment = {
  production: true,
  // true only in the DEV environment build (-c devenv): DEV ribbon on the logos, red topbar strip, dev favicon
  isDevEnv: true,
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },
  tokenKey: 'fd-tokens',
  profileKey: 'user',
  layoutSettingsKey: 'fd-layout',
  languageCookieKey: 'lang',
  permissionKey: 'permissionKey',
  userPermissionsKey: 'userPermissionsKey',
  cookieExpireTime: 30 * 24 * 60 * 60,
  apiUrl: 'https://nirlat.api.dev.shtibel.com/api',
  imageUrl: 'https://nirlat-assets.s3.il-central-1.amazonaws.com/',
  publicUrl: 'https://nirlat.api.dev.shtibel.com/',
  awsenv: 'dev',
  businessCardUrl: 'https://nirlat.card.dev.shtibel.com/',
};
